import React, { useEffect, useRef, useState } from "react";

function CaseStudyVideoGallery({ videos }) {
  const [activeVideo, setActiveVideo] = useState(null);
  const videoRef = useRef(null);

  const closeVideo = () => {
    if (videoRef.current) videoRef.current.pause();
    setActiveVideo(null);
  };

  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === "Escape") setActiveVideo(null);
    };
    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, []);

  return (
    <>
      {activeVideo && (
        <div className="case-study-video-modal" role="dialog" aria-modal="true" aria-label={activeVideo.title}>
          <button onClick={closeVideo} className="case-study-video-close" aria-label="Close video">
            &times;
          </button>
          <video ref={videoRef} src={activeVideo.video_url} controls autoPlay />
          <div className="case-study-video-modal-title">{activeVideo.title}</div>
        </div>
      )}

      <div className="row justify-content-center g-4">
        {videos.map((video) => (
          <div key={video.id} className="col-12 col-sm-6 col-lg-4">
            <button
              type="button"
              className="case-study-card case-study-video-card"
              onClick={() => setActiveVideo(video)}
              aria-label={`Play ${video.title}`}
            >
              <video src={video.video_url} muted preload="metadata" playsInline />
              <div className="case-study-video-title">{video.title}</div>
              <div className="video-btn">
                <i className="ti ti-player-play"></i>
                <span className="video-sonar"></span>
              </div>
            </button>
          </div>
        ))}
      </div>
    </>
  );
}

export default CaseStudyVideoGallery;
